<template>
  <v-row justify="center">
    <v-col cols="8">
      <v-card>
        <v-card-text>
          <v-col />
          <v-col>
            <v-select
              v-model="campaignId"
              :items="campaigns"
              item-text="name"
              item-value="campaignId"
              label="Счёт Кредит"
            />
          </v-col>
          <v-col>
            <v-text-field label="Сумма" />
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios"
import CampaignModel from "../../models/campaign.model"

export default {
  name: "TransactionEdit",
  data: () => ({
    customerId: null,
    campaigns: [],
    campaignId: 0,
  }),
  beforeMount () {
    const that = this
    this.customerId = this.$store.getters["customer_store/getCustomerId"]
    axios
        .get(`${process.env.VUE_APP_LOYALTY_URL}campaigns/` + this.customerId)
        .then(function (response) {
          // console.clear();
          console.log(response.data)

          console.log("---------------")
          response.data.map((m) => console.log(m))
          that.campaigns = response.data.map((k) => that.setItems(k))
        })
        .catch(function (error) {
          console.log(error)
        })
  },
  methods: {
    changeSelect () {
    },
    setItems (data) {
      return Reflect.construct(CampaignModel, [data])
    },
  },
}
</script>

<style scoped></style>
